import { __assign } from "tslib";
// DS2.5.3, DS2.5.3M
import React, { useContext, useMemo } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import Comment from '../../Icons/24x24/Comment';
import CommentOutline from '../../Icons/24x24/CommentOutline';
import FavStar from '../../Icons/24x24/FavStar';
import FavStarFill from '../../Icons/24x24/FavStarFill';
import { IconSize } from '../../Icons/IconWrap';
import shortenNumber from '../../../utils/shortenNumber';
import { setRef } from '../../../utils/refHelpers';
import s from './ThumbIconButton.scss';
var ThumbIconButton = React.forwardRef(function (_a, ref) {
    var type = _a.type, _b = _a.isEngaged, isEngaged = _b === void 0 ? false : _b, _c = _a.statValue, statValue = _c === void 0 ? 0 : _c, _d = _a.showStatValue, showStatValue = _d === void 0 ? true : _d, className = _a.className, href = _a.href, biData = _a.biData, onClick = _a.onClick;
    var isMobile = useContext(MobileContext);
    var icon = useMemo(function () {
        var iconProps = {
            size: isMobile ? IconSize.MEDIUM : IconSize.SMALLER,
            disableDefaultColors: true,
            className: s['icon'],
        };
        switch (type) {
            case 'comment':
                return isEngaged ? (React.createElement(Comment, __assign({}, iconProps))) : (React.createElement(CommentOutline, __assign({}, iconProps)));
            case 'fave':
                return isEngaged ? (React.createElement(FavStarFill, __assign({}, iconProps))) : (React.createElement(FavStar, __assign({}, iconProps)));
            default:
                return null;
        }
    }, [isEngaged, isMobile, type]);
    return (React.createElement(PlainButtonOrLink, { innerRef: function (node) { return setRef(ref, node); }, href: href, onClick: onClick, className: classnames(s['root'], className), biData: biData },
        icon,
        showStatValue && (React.createElement("span", { className: s['value'] }, shortenNumber(statValue)))));
});
ThumbIconButton.displayName = 'ThumbIconButton';
export default ThumbIconButton;
//# sourceMappingURL=ThumbIconButton.js.map